
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 71.29 18.82"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"-e-iconTimerStyle3"}},[_c('g',{attrs:{"data-name":"-e-iconTimerStyle3-2"}},[_c('path',{attrs:{"d":"M9.41 18.82a9.41 9.41 0 119.41-9.41 9.42 9.42 0 01-9.41 9.41zm0-15.32a5.91 5.91 0 105.91 5.91A5.92 5.92 0 009.41 3.5zM35.65 18.82a9.41 9.41 0 119.41-9.41 9.42 9.42 0 01-9.41 9.41zm0-15.32a5.91 5.91 0 105.91 5.91 5.92 5.92 0 00-5.91-5.91zM61.88 18.82a9.41 9.41 0 119.41-9.41 9.42 9.42 0 01-9.41 9.41zm0-15.32a5.91 5.91 0 105.91 5.91 5.92 5.92 0 00-5.91-5.91z"}})])])])
          )
        }
      }
    